<template>
  <div>
    <b-list-group horizontal>
      <b-list-group-item
        id="all"
        class="d-flex justify-content-between align-items-center rounded-pill cursor-pointer border-0"
        :class="isActive('all')"
        :style="toggleLiItemColor('all')"
        @click="handleClick('all')"
      >
        <div class="d-flex align-items-center flex-shrink-0 key-width mr-1">
          <b-icon icon="arrow-left-right" class="text-primary mr-1"></b-icon>
          <span class="font-weight-bold text-nowrap">Total Connections:</span>
        </div>
        <div class="flex-grow-1 text-left">
          {{ formatNumberWithCommas(this.networkCounts.total) }}
        </div>
      </b-list-group-item>
      <b-list-group-item
        class="d-flex justify-content-between align-items-center rounded-pill border-0 cursor-pointer"
        :class="isActive('inbound')"
        :style="toggleLiItemColor('inbound')"
        @click="handleClick('inbound')"
      >
        <div class="d-flex align-items-center flex-shrink-0 key-width mr-1">
          <b-icon icon="arrow-right" class="text-primary mr-1"></b-icon>
          <span class="font-weight-bold text-nowrap">Inbound:</span>
        </div>
        <div class="flex-grow-1 text-left">
          {{ formatNumberWithCommas(this.networkCounts.inbound) }}
        </div>
      </b-list-group-item>
      <b-list-group-item
        class="d-flex justify-content-between align-items-center rounded-pill border-0 cursor-pointer"
        :class="isActive('outbound')"
        :style="toggleLiItemColor('outbound')"
        @click="handleClick('outbound')"
      >
        <div class="d-flex align-items-center flex-shrink-0 key-width mr-1">
          <b-icon icon="arrow-left" class="text-primary mr-1"></b-icon>
          <span class="font-weight-bold text-nowrap">Outbound:</span>
        </div>
        <div class="flex-grow-1 text-left">
          {{ formatNumberWithCommas(this.networkCounts.outbound) }}
        </div>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import colorPalette from '@/xvisor/constants/colorPalette';
import formatNumberWithCommas from '@/xvisor/utilities/addCommaToNumber';
import themeStyle from '@/xvisor/utilities/themeStyle';

export default {
  props: {
    timeRange: {
      type: Object,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loaded: false,
      networkCounts: { total: 0, inbound: 0, outbound: 0 },
      show: 'all',
    };
  },
  mounted() {
    this.httpGet();
  },
  computed: {
    hasData() {
      return this.loaded && this.networkCounts && this.networkCounts.total > 0;
    },
  },
  methods: {
    httpGet() {
      this.$http
        .get(this.url, {
          params: {
            start: this.timeRange.start.toISOString(),
            end: this.timeRange.end.toISOString(),
            xtendId: this.$route.params.id,
          },
        })
        .then((response) => {
          this.networkCounts = response.data;
        })
        .finally(() => {
          this.loaded = true;
        });
    },
    isActive(direction) {
      return this.show === direction ? 'active' : '';
    },
    toggleLiItemColor(direction) {
      if (this.show !== direction) {
        return '';
      }
      const bgColor = themeStyle.styleToggle(colorPalette.lightThemeGreyBorder, colorPalette.blueBackground);
      const textColor = themeStyle.styleToggle(colorPalette.lightThemeText, colorPalette.white);
      return {
        'background-color': bgColor,
        color: textColor,
      };
    },
    formatNumberWithCommas,
    handleClick(direction) {
      this.show = direction;
      this.$emit('filterDirection', direction);
    },
  },
  watch: {
    timeRange() {
      this.httpGet();
    },
  },
};
</script>

<style scoped>
.list-group-item.active{
  border: none !important;
  opacity: 1 !important;
  color: colorPa!important;
  pointer-events: none;
}
</style>
